export enum SignInErrorCodes {
  INVALID_USER,
  NO_ORG_ACCESS,
  MFA_REQUIRES_PASSWORD,
}
